import { Select, Tag } from 'antd';
import { attendanceStatusOptions, getAttendanceStatus } from '../../../utils/registrantAttendance';

const presentations = {
    attending: { label: 'Attending', color: '#166534', background: '#dcfce7', borderColor: '#86efac' },
    notAttending: { label: 'Not attending', color: '#991b1b', background: '#fee2e2', borderColor: '#fca5a5' },
    notImported: { label: 'Not imported', color: '#475569', background: '#f1f5f9', borderColor: '#cbd5e1' },
};

export default function AttendanceStatusChip({ registrant, labelPrefix, closable, onClose, onMouseDown }) {
    const { label, ...colors } = presentations[getAttendanceStatus(registrant)];
    return <Tag closable={closable} onClose={onClose} onMouseDown={onMouseDown}
        aria-label={`Venue attendance: ${label}`}
        title="Venue attendance confirmation for this whole registration"
        style={{ ...colors, borderRadius: 999, margin: 0, fontSize: 11, fontWeight: 600, lineHeight: '20px', padding: '0 8px' }}>
        {labelPrefix ? `${labelPrefix} · ${label}` : label}
    </Tag>;
}

export function AttendanceStatusFilter({ value, onChange }) {
    return <Select aria-label="Filter registrants by venue attendance" value={value} onChange={onChange}
        style={{ width: 210, maxWidth: '100%' }} options={attendanceStatusOptions} />;
}
